import {
  Directive,
  ElementRef,
  Input,
  Optional,
  Renderer2,
  Self,
} from '@angular/core';
import {
  MediaMonitor,
  ShowHideDirective as FlexLayoutShowHideDirective,
} from '@angular/flex-layout';
import { LayoutDirective } from './layout.directive';

@Directive({
  selector: `
    [flLayoutShow],
    [flLayoutShow.mobile],
    [flLayoutShow.tablet],
    [flLayoutShow.desktop-small],
    [flLayoutShow.desktop-large],
    [flLayoutShow.desktop-xlarge],
    [flLayoutShow.desktop-xxlarge],
  `,
})
export class LayoutShowDirective extends FlexLayoutShowHideDirective {
  constructor(
    monitor: MediaMonitor,
    @Optional()
    @Self()
    protected _layout: LayoutDirective,
    protected elRef: ElementRef,
    protected renderer: Renderer2,
  ) {
    super(monitor, _layout, elRef, renderer);
  }

  @Input('flLayoutShow')
  set show(val: any) {
    this._cacheInput('show', val);
  }
  @Input('flLayoutShow.mobile')
  set showMobile(val: any) {
    this._cacheInput('showMobile', val);
  }
  @Input('flLayoutShow.tablet')
  set showTablet(val: any) {
    this._cacheInput('showTablet', val);
  }
  @Input('flLayoutShow.desktop-small')
  set showDesktopSmall(val: any) {
    this._cacheInput('showDesktopSmall', val);
  }
  @Input('flLayoutShow.desktop-large')
  set showDesktopLarge(val: any) {
    this._cacheInput('showDesktopLarge', val);
  }
  @Input('flLayoutShow.desktop-xlarge')
  set showDesktopXLarge(val: any) {
    this._cacheInput('showDesktopXLarge', val);
  }
  @Input('flLayoutShow.desktop-xxlarge')
  set showDesktopXXLarge(val: any) {
    this._cacheInput('showDesktopXXLarge', val);
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/es/webapp/src/app/@shared/ui/layout/layout-show.directive.ts